import React, { useState, useEffect, useRef } from 'react'
import { FormattedMessage, useIntl } from 'react-intl';
import {Button, Typography} from 'antd'
import axios from 'axios'
import LoadingControl from '../controls/Loading';
import PolledServersTable from '../controls/PolledServersTable';
import AddPulledServer from '../controls/AddPulledServer';
import { sendSyncPost } from '../utils/utils';

const DBPollingPane = (props) => {  
    
    const [state, setState] = useState({
        error: null,
        isLoaded: false,
        edit_mode: false,
        need_update: false
    });

    var edited_server = useRef();
    var polling_settings = useRef({});

    const intl = useIntl();

    function OnAdd()
    {
        edited_server.current = {
            "serverName" : "",
            "serverURL" : "",
            "pollingInterval" : 60,
            "extractJobData" : 0,
            "name_readonly" : false
        };

        setState({...state, edit_mode: true});
    }

    function onCancleEdit()
    {
        setState({...state, edit_mode: false});
    }

    async function onSubmit(server)
    {
        sendSyncPost('/db_polling', server, intl); 
        setState({...state, isLoaded: false});

        setTimeout(() => {
            getData();
          }, 1000);
    }

    function onEdit(record)
    {
        edited_server.current = {
            "serverName" : record.name,
            "serverURL" : record.pollingUrl,
            "pollingInterval" : record.pollingInterval,
            "extractJobData" : record.extractJobData,
            "isPolled" : true,
            "name_readonly" : true
        };

        setState({...state, edit_mode: true});
    }

    function onDelete(record)
    {
        sendSyncPost('/db_polling', record, intl);
        setState({...state, isLoaded: false});

        setTimeout(() => {
            getData();
          }, 1000);

    }

    function getData() 
    {  
        axios("/db_polling")
        .then(res => {
            polling_settings.current = res.data;
            setState(prevState => ({
                ...prevState,
                error: null,
                isLoaded: true,
                edit_mode: false
            }));
        })
        .catch(err => {
            polling_settings.current = null;
            setState(prevState => ({
                ...prevState,
                error: err,
                isLoaded: false,
            }));
        });     
    }

    useEffect(() => {
            getData();
    }, []);
  
    if(state.error != null)
    {
        return (
            <div>
                <h3>{state.error.message}</h3>
            </div>
        );
    }
    else if (!state.isLoaded)
    {
        return (
            <div><LoadingControl/></div>
        );
    }
    else
    {
        return (
            <div>                
                <h4>This server URL for polling: <Typography.Text keyboard copyable>{polling_settings.current.ServerPollingURL}</Typography.Text></h4>
                {!state.edit_mode && <div className = "history-pane-header">
                    <Button type="default" onClick = {() => OnAdd()}><FormattedMessage id="AddPolledServer"/></Button>
                </div>}                
                {state.edit_mode && <AddPulledServer data = {edited_server.current} onCancel = {() => onCancleEdit()} onSubmit = {(server) => onSubmit(server)}/>}
                <PolledServersTable data = {polling_settings.current.servers} onEdit = {(record) => onEdit(record)} onDelete = {(record) => onDelete(record)}/>                
            </div>
        );   
    }
}
  
export default DBPollingPane;